module.exports = __webpack_public_path__ + "assets/granimjs.145fd6da.svg";